export const VoiceInputHandler = {
    init: function () {
      this.cacheSelectors();
      this.checkBrowser();
      this.setupSpeechRecognition();
    },
  
    cacheSelectors: function () {
      this.voiceButton = document.getElementById('voiceButton');
      this.startBtn = document.getElementById('startBtn');
      this.voiceInput = document.getElementById('voiceInput');
    },
  
    checkBrowser: function () {
      if (this.isFirefox()) {
        if (this.voiceButton) {
          this.voiceButton.style.display = 'none';
        }
      }
    },
  
    isFirefox: function () {
      return navigator.userAgent.toLowerCase().includes('firefox');
    },
  
    setupSpeechRecognition: function () {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  
      if (SpeechRecognition) {
        this.recognition = new SpeechRecognition();
        this.recognition.lang = 'pt-BR';
        this.recognition.interimResults = false;
        this.recognition.maxAlternatives = 1;
  
        this.bindSpeechEvents();
      }
    },
  
    bindSpeechEvents: function () {
      if (!this.recognition) return;
  
      if (this.startBtn) {
        this.startBtn.addEventListener('click', this.handleStart.bind(this));
      }
  
      this.recognition.addEventListener('result', this.handleResult.bind(this));
      this.recognition.addEventListener('end', this.handleEnd.bind(this));
    },
  
    handleStart: function () {
      this.recognition.start();
      this.startBtn.textContent = '🎤 Ouvindo...';
    },
  
    handleResult: function (event) {
      const transcript = event.results[0][0].transcript;
      if (this.voiceInput) {
        this.voiceInput.value = transcript;
      }
    },
  
    handleEnd: function () {
      if (this.startBtn) {
        this.startBtn.textContent = '🎤 Capturar Voz';
      }
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    VoiceInputHandler.init();
  });
  